/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Card, Spinner, FormGroup } from "reactstrap";
import ES1UpdateReport from "./ES1UpdateReport";
import ES4UpdateReport from "./ES4UpdateReport";
import ES5PA2UpdateReport from "./ES5part2UpdateReport";

const ES5part2ReportEmployment = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [Totall, setTotal] = useState([]);
    const [GTotal, setGTotal] = useState(0);
    const [userData, setuserData] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [employmentId, setemloymentId] = useState(props.employmentId);
    const today = new Date();
    const tableRef = useRef(null);
    const [Draft, setDraft] = useState(true);
    const [loading, setloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(props.userid),
        ParametersId: Number(props.parametersId),
        month: props.monthId,
        dummymonth: month1[props.monthId],
        year: props.yearId,
        EmploymentRefId: props.employmentRefId,
    });

    const Total = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES3DetailsTotal1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setTotal(data[0])
                })


    };
    const getdata2 = async (emp) => {

        const sendData = {

            EmploymentRefId: Number(formData.EmploymentRefId),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Getparameters', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setdataactive(data)
                    /*const maindata = data.filter(a => a.parentId !== 0)
                    console.log(maindata.length)*/
                })


    };
    const getdata = async () => {

        const sendData = {
            EmploymentId: Number(props.employmentId),
            UserId: Number(props.userid),
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Viewalldata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)
                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentId)
                        getdata2(data.employmentId)
                        Total(data.employmentId)
                        setuserData(data)
                    }
                })
    };


    useEffect(() => {
        setloading(true)
        getdata()
    }, [props.monthId, props.yearId, props.employmentId, props.state, props.center])


    return (


        <>

        { loading === false ? dataactive.map((details, index) =>

            details.parentId === 0 ?
                null :
                <ES5PA2UpdateReport totall={props.totall} setmodal={props.setmodal} userid={props.userid} parametersId={details.parametersId} index={index + 1} state={props.state} center={props.center} month={formData.dummymonth} year={formData.year} value={details.value} setGTotal={setGTotal} GTotal={GTotal} edit={false} es1detailsId={details.es1detailsId} employmentId={employmentId} />

        ) : <Spinner color="success" />}
                                                   
        </>                                              

                                    
);
};

export default ES5part2ReportEmployment;
